export enum LicenseTypes {
  ONBOARDING = 22,
  UB_AMAZON = 27,
  UB_WASABI = 28
}

export const NAValue = 'N/A';
